<div kalDialogHeader>
    <div class="kal-dialog__title">{{ title }}</div>
</div>

<div kalDialogContent class="container">

    <div *ngIf="data.countContactedBeneficiaries > 0" class="gup-C-flexGroup -row -justifyStart -alignCenter">

        <kal-icon class="gup-U-color--green">done</kal-icon>

        <span>{{ content }}</span>

    </div>

    <div *ngIf="data.nonContactableBeneficiariesList | arrayNotEmpty">

        <ng-container i18n>

            <div>
                {nonContactableBeneficiariesList.length, plural,
                    =0 { Tous les bénéficiaire ont été contactés. }
                    one { {{ nonContactableBeneficiariesList[0].Nom + ' ' + nonContactableBeneficiariesList[0].Prenom }} n'a pas pu être contacté car son adresse e-Mail n'est pas valide : }
                    other { {{ nonContactableBeneficiariesList.length }} bénéficiaires n'ont pas pu être contactés car leur adresse e-Mail n'est pas valide : }}
            </div>

        </ng-container>

        <div *ngFor="let beneficiary of nonContactableBeneficiariesList | slice:0:10">
            - {{ beneficiary.Nom + ' ' + beneficiary.Prenom }}
        </div>

        <div *ngIf="nonContactableBeneficiariesList.length > 10">
            - ...
        </div>

        <a class="gup-O-link -secondary"
           (click)="export()">
            Exporter la liste complète
        </a>

    </div>

</div>

<div kalDialogFooter>

    <div class="gup-C-validationArea gup-O-list">

        <div class="gup-O-list__item">
            <kal-button kalTheme="secondary"
                        (click)="close()">
                Fermer
            </kal-button>
        </div>

    </div>

</div>
